export const CalculatorConstants = {
  minValueEstimation: 50_000,
};
